function injectStyle (ssrContext) {
  require("!!../../../../node_modules/.store/extract-text-webpack-plugin@2.1.2/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-0eeeaa57\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector?type=styles&index=0!./questionBankManagenment.vue")
}
var normalizeComponent = require("!../../../../node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector?type=script&index=0!./questionBankManagenment.vue"
import __vue_script__ from "!!babel-loader!../../../../node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector?type=script&index=0!./questionBankManagenment.vue"
/* template */
import __vue_template__ from "!!../../../../node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0eeeaa57\",\"hasScoped\":false,\"buble\":{\"transforms\":{}}}!../../../../node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector?type=template&index=0!./questionBankManagenment.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/mall/examination/questionBankManagenment.vue
// module id = 1188
// module chunks = 72